import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const MultipleChoiceMultipleIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M13.9997 2.83334C14.2758 2.83334 14.4997 3.0572 14.4997 3.33334C14.4997 3.60949 14.2758 3.83334 13.9997 3.83334H8.66669C8.39054 3.83334 8.16669 3.60949 8.16669 3.33334C8.16669 3.0572 8.39054 2.83334 8.66669 2.83334H13.9997Z"
      fill="currentColor"
    />
    <path
      d="M13.9997 7.5C14.2758 7.5 14.4997 7.72386 14.4997 8C14.4997 8.27614 14.2758 8.5 13.9997 8.5H8.66669C8.39054 8.5 8.16669 8.27614 8.16669 8C8.16669 7.72386 8.39054 7.5 8.66669 7.5H13.9997Z"
      fill="currentColor"
    />
    <path
      d="M13.9997 12.1667C14.2758 12.1667 14.4997 12.3905 14.4997 12.6667C14.4997 12.9428 14.2758 13.1667 13.9997 13.1667H8.66669C8.39054 13.1667 8.16669 12.9428 8.16669 12.6667C8.16669 12.3905 8.39054 12.1667 8.66669 12.1667H13.9997Z"
      fill="currentColor"
    />
    <path
      d="M5.64649 9.64648C5.84175 9.45121 6.15826 9.45121 6.35352 9.64648C6.54878 9.84174 6.54878 10.1582 6.35352 10.3535L3.68653 13.0205C3.49124 13.2154 3.17465 13.2157 2.9795 13.0205L1.64649 11.6865C1.45139 11.4912 1.45128 11.1747 1.64649 10.9795C1.84171 10.7844 2.1583 10.7844 2.35352 10.9795L3.33301 11.959L5.64649 9.64648Z"
      fill="currentColor"
    />
    <path
      d="M5.64649 2.97982C5.84175 2.78456 6.15826 2.78456 6.35352 2.97982C6.54878 3.17508 6.54878 3.49159 6.35352 3.68685L3.68653 6.35384C3.49124 6.54878 3.17465 6.549 2.9795 6.35384L1.64649 5.01986C1.45139 4.82458 1.45128 4.50804 1.64649 4.31283C1.84171 4.11778 2.1583 4.11778 2.35352 4.31283L3.33301 5.29232L5.64649 2.97982Z"
      fill="currentColor"
    />
  </svg>
);
